<template>
  <div v-show="getFiltersLength && !typeQueryState" v-if="!isTabletView"
       :class="{
       'q-d-block ': canShowFiltersOnMobile,
       'q-d-none': !canShowFiltersOnMobile,
       'serp__filters--mobile  q-slide-in-left q-position-fixed q-top-0 q-left-0 q-bottom-0 q-right-0 q-w-100 q-h-100 ': canShowFiltersOnMobile && isMobileView
       }"
       class="serp__filters-container q-col-md-4 q-col-lg-3 q-col-sm-12 q-d-md-block q-py-3 q-py-md-1 q-position-relative q-bg-light">
    <ComponentLoader :loading="isLoading || (productIsLoading && isMobileView)"/>
    <CloseButton/>
    <FiltersHeaderContainer v-if="isMobileView"/>
    <FiltersListContainer/>
    <UsedFilterContainer v-if="isMobileView"/>
    <ClearFiltersButtonMobile v-if="isMobileView"/>
    <div v-if="isMobileView" class="mobile_filters--container q-pt-3 q-border-top">
      <LinearLoader :loading="isLoading || (productIsLoading && isMobileView)"/>
      <AppendFiltersButton/>
    </div>


  </div>
</template>

<script setup lang="ts">
import {inject, onMounted, onUnmounted, watch, computed} from "vue";
import FiltersListContainer from '@/components/SerpPage/FiltersContainer/FiltersList/FiltersListContainer.vue'
import FiltersHeaderContainer from '@/components/SerpPage/FiltersContainer/Header/FiltersHeaderContainer.vue'
import CloseButton from "@/components/SerpPage/FiltersContainer/Header/CloseButton.vue";
import AppendFiltersButton from "@/components/SerpPage/ResultsContainer/ButtonsContainer/AppendFiltersButton.vue";
import ComponentLoader from '@/components/ComponentLoader.vue'


import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {useMobileViewStore} from "@/store/MobileViewStore";
import {SmartSearchConfigInterface} from "@/core/types";
import {storeToRefs} from "pinia";
import UsedFilterContainer from "@/components/SerpPage/FiltersContainer/UsedFilterContainer.vue";
import ClearFiltersButtonMobile
  from "@/components/SerpPage/FiltersContainer/ClearFiltersButton/ClearFiltersButtonMobile.vue";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import LinearLoader from "@/components/LinearLoader.vue";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchConfig = inject<SmartSearchConfigInterface>('SmartSearchConfig')!
const filtersStore = useFiltersStore();
const mobileViewStore = useMobileViewStore()
const {canShowFiltersOnMobile, isLoading, getFiltersLength} = storeToRefs(filtersStore)
const {isMobileView, isTabletView} = storeToRefs(mobileViewStore)
const serpStore = useSerpResultsStore();
const {allowEmptyQuery} = SmartSearchConfig.value.serp.query


const {query, loading: productIsLoading} = storeToRefs(serpStore)
const typeQueryState = computed(() => {
  return !productIsLoading.value && !allowEmptyQuery && !query.value
})
watch(canShowFiltersOnMobile, (newValue) => {
  filtersStore.setBodyScroll(!newValue);
});

// @TODO sprawdzić czy to potrzebne
// onMounted(() => {
//   // filtersStore.fetchFilters();
//   window.addEventListener('popstate', () => {
//     filtersStore.fetchFilters();
//   });
// });
//
// onUnmounted(() => {
//   window.removeEventListener('popstate', () => {
//     filtersStore.fetchFilters();
//   });
// });

</script>

<style scoped>
.serp__filters-container {
  position: relative;
}

.serp__filters--mobile {
  position: fixed !important;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  background-color: white;
  overflow-y: scroll;
  height: calc(100dvh - 40px) !Important;
}

.mobile_filters--container {
  position: fixed;
  bottom: 0;
  background-color: #fff;
  width: 100%;
  z-index: 9999;
}

</style>
